var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { FactoryContent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
export var searchPattern = function (rowIndex, cellIndex, data) {
    if (data === void 0) { data = {}; }
    var matching = data["[".concat(rowIndex, "][").concat(cellIndex, "]")] ||
        data["[*][".concat(cellIndex, "]")] ||
        data["[".concat(rowIndex, "][*]")] ||
        data["[*][*]"];
    return (matching === null || matching === void 0 ? void 0 : matching.design) || matching;
};
var createCellContentData = function (cellStructure, overwrittenDesignData, isBody) {
    var cellComponent = cellStructure[0], innerCellDesign = cellStructure[1], innerCellConfiguration = cellStructure[2];
    var _a = (overwrittenDesignData === null || overwrittenDesignData === void 0 ? void 0 : overwrittenDesignData.cell) || [], overwrittenComponent = _a[0], overwrittenDesign = _a[1], overwrittenConfig = _a[2];
    var usingComponent = overwrittenComponent || (overwrittenDesignData === null || overwrittenDesignData === void 0 ? void 0 : overwrittenDesignData.component) || cellComponent;
    return [
        isBody ? usingComponent : cellComponent,
        isBody ? overwrittenDesign || innerCellDesign : innerCellDesign,
        isBody ? __assign(__assign({}, innerCellConfiguration), (overwrittenConfig || {})) : innerCellConfiguration,
    ];
};
export var TableRow = function (design) {
    var _a = useDesign((design === null || design === void 0 ? void 0 : design.design) || design), config = _a.config, schema = _a.schema;
    var _b = design || {}, rowIndex = _b.rowIndex, rowData = _b.rowData, cellsDesign = _b.cellsDesign, overwriteDesign = _b.overwriteDesign, conditionalDesign = _b.conditionalDesign, tableData = _b.tableData, globalData = _b.globalData, isBody = _b.isBody;
    var fixedConfig = !config.cells
        ? []
        : config.cells.map(function (cellStructure, cellIndex) {
            var _a = cellStructure[3] || {}, customValues = _a.customValues, displayQuery = _a.displayQuery, extraCellConfiguration = __rest(_a, ["customValues", "displayQuery"]);
            var overwrittenDesignData = searchPattern(rowIndex, cellIndex, overwriteDesign);
            var conditionedDesign = searchPattern(rowIndex, cellIndex, conditionalDesign);
            var hasConditionalDesign = conditionedDesign && (conditionedDesign === null || conditionedDesign === void 0 ? void 0 : conditionedDesign.condition) && (conditionedDesign === null || conditionedDesign === void 0 ? void 0 : conditionedDesign.design);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var evalData = {
                rowData: rowData,
                tableData: tableData,
                globalData: globalData,
                rowIndex: rowIndex,
                cellIndex: cellIndex,
            };
            var useConditionalDesign = hasConditionalDesign
                ? // eslint-disable-next-line no-eval
                    eval("".concat(conditionedDesign.condition, "(evalData)"))
                : false;
            var conditionalResult = useConditionalDesign
                ? conditionedDesign.design
                : (conditionedDesign === null || conditionedDesign === void 0 ? void 0 : conditionedDesign.default) || overwrittenDesignData;
            return [
                'TableCell',
                (hasConditionalDesign ? conditionalResult : overwrittenDesignData) ||
                    cellsDesign ||
                    (config === null || config === void 0 ? void 0 : config.cellsDesign),
                {
                    tableData: tableData,
                    globalData: globalData,
                    rowData: rowData,
                    rowIndex: rowIndex,
                    cellIndex: cellIndex,
                    customValues: customValues,
                    displayQuery: displayQuery,
                    extraCellConfiguration: extraCellConfiguration,
                    innerCellDesign: createCellContentData(cellStructure, overwrittenDesignData, isBody),
                },
            ];
        });
    return (_jsx(GenericComponent, __assign({ schema: schema, as: "tr" }, { children: _jsx(FactoryContent, { config: { content: fixedConfig, displayQueries: config.displayQueries }, autoIndex: true, values: globalData }) })));
};
TableRow.displayName = 'TableRow';
